import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { RichText } from 'prismic-reactjs'
import Prismic from 'prismic-javascript'

import Page from '../../components/Page'

import './style.css'

const apiEndpoint = 'https://buda-vet.cdn.prismic.io/api/v2'

class Service extends Component {
  state = {
    service: {},
  }

  async componentDidMount() {
    const api = await Prismic.getApi(apiEndpoint)
    const serviceId = this.props.match.params.id

    api.getByID(serviceId).then(apiResult => {
      console.log(apiResult.data)
      this.setState({
        service: { ...apiResult.data, id: apiResult.id },
      })
    })
  }

  render() {
    const service = this.state.service
    if (!service.id) return null
    return (
      <Page title={service.nev} noHero>
        <div className="sectionTitle">{service.nev}</div>
        <Grid className="NewsItem">
          <Row>
            <Col mdOffset={2} md={8}>
              <Col>{RichText.render(service.torzs || [])}</Col>
            </Col>
          </Row>
        </Grid>
      </Page>
    )
  }
}

export default Service



// WEBPACK FOOTER //
// ./src/pages/Service/index.js